import { SAVE_ALL_TORI, GET_NET_RELATION,TORI_SEARCH } from "Stores/actionTypes";
import NetService from "Services/http/endpoints/properties/NetService";
import StatusHandler from "Helpers/StatusHandler";
import { read } from "Helpers/LocalStorage";
import { analyzePrice } from "Helpers/analyzePrice";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";

export const GetAllTori = (params) => {
  return async (dispatch) => {
    try {
      const response = await NetService.GetAllTori(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = analyzePrice(response.data.Value);
        const limit = response.data.Pagination.Limit;
        const page = response.data.Pagination.Page;
        const updatedData = data.map((data, index) => {
          return {
            ...data,
            num: ((page - 1 ) * limit) + index + 1,
          };
        });
        dispatch({
          type: SAVE_ALL_TORI,
          toriData: updatedData,
          toriDataPagination:response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const EditPriceTori = (data) => {
  return async (dispatch) => {
    try {
      const response = await NetService.EditPriceTori(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('The_net_price_was_successfully_edited'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const putEditTori = (data) => {
  return async (dispatch) => {
    try {
      const response = await NetService.EditTori(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Torry_edited_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const InsertToriData = (data) => {
  return async (dispatch) => {
    try {
      const response = await NetService.InsertToriData(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Lace_added_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteTori = (data) => {
  return async (dispatch) => {
    try {
      const response = await NetService.deleteTori(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Tori_removed_successfully'),
          customClass: "success"
        });
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationNet(params));
        }
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getRelationNet = (params) => {
  return async (dispatch) => {
    try {
      const response = await NetService.getRelationNet(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: GET_NET_RELATION,
          dataRelationTori: response.data.Value.List,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const disableTori = (data) => {
  return async (dispatch) => {
    try {
      const response = await NetService.disableTori(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const changeToriSearch = (toriDataSearch) => (dispatch) => {
  dispatch({
    type: TORI_SEARCH,
    toriDataSearch: toriDataSearch,
  });
};
